import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const ReactivateMemberForWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReactivateMemberForWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactivateMemberForWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ReactivateMemberForWorkspace","document":ReactivateMemberForWorkspaceDocument}} as const;
export type ReactivateMemberForWorkspaceMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type ReactivateMemberForWorkspaceMutation = (
  { __typename: 'Mutation' }
  & { reactivateMemberForWorkspace?: Types.Maybe<(
    { __typename: 'ReactivateMemberForWorkspace_Response' }
    & Pick<Types.ReactivateMemberForWorkspace_Response, 'id'>
  )> }
);

export type ReactivateMemberForWorkspaceMutationFn = Apollo.MutationFunction<
  ReactivateMemberForWorkspaceMutation,
  ReactivateMemberForWorkspaceMutationVariables
>;

/**
 * __useReactivateMemberForWorkspaceMutation__
 *
 * To run a mutation, you first call `useReactivateMemberForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateMemberForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateMemberForWorkspaceMutation, { data, loading, error }] = useReactivateMemberForWorkspaceMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useReactivateMemberForWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReactivateMemberForWorkspaceMutation,
    ReactivateMemberForWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReactivateMemberForWorkspaceMutation,
    ReactivateMemberForWorkspaceMutationVariables
  >(ReactivateMemberForWorkspaceDocument, options);
}
export type ReactivateMemberForWorkspaceMutationHookResult = ReturnType<
  typeof useReactivateMemberForWorkspaceMutation
>;
export type ReactivateMemberForWorkspaceMutationResult =
  Apollo.MutationResult<ReactivateMemberForWorkspaceMutation>;
export type ReactivateMemberForWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    ReactivateMemberForWorkspaceMutation,
    ReactivateMemberForWorkspaceMutationVariables
  >;
